$(document).ready(function(){
  

  // Sanyam

  // Roll 16
  $('#shopify-section-template--22096177529176__rich_text_tYN3fJ .isolate .rich-text__blocks.center > h2').attr('aria-level','1');

  // Roll 29
  $('.main-content .grid__item.medium-up--five-sixths.medium-up--push-one-twelfth .rte > p#opt-out-initial > a').removeAttr('title');

  // Roll 31
  // $('#shopify-section-template--22096177627480__1712139406cd7e4f29 form .kl-private-reset-css-Xuajs1.go3176171171 > p > span[style="color: rgb(0, 0, 0); font-size: 50px; font-family: Ubuntu, Helvetica, Arial, sans-serif; font-weight: bold; font-style: normal;"]').attr('role','heading').attr('aria-level','1');

  // Roll 35
  $('#shopify-section-template--22096177693016__image_banner_nwEEzh > div .banner__media.media.scroll-trigger.animate--fade-in > img').attr('alt','Home Hero Be The Hero In Your Home image');


  // Roll 37
  $('.quantity__button.no-js-hidden.disabled').attr('aria-disabled','true');

  // Roll 40
  $('.product-form__buttons .product-form__submit.button.button--full-width.button--secondary').removeAttr('aria-haspopup');
  $('.product-form__buttons .product-form__submit.button.button--full-width.button--secondary').attr('role','link');

  
  setTimeout(() => {
      $('.product-form__buttons .shopify-payment-button .shopify-cleanslate [data-testid="ShopifyPay-button"]').attr("role","link");
  
      // Roll 42
      $('.user-icon').attr('role','image').attr('aria-label','Verified');

  }, 1000);

  $("<p class='required-indication'>Fields marked with an asterisk (*) are required.</p>").insertBefore('#ContactForm');

  $('[data-testid="form-row"] > div #email_108602549').attr('aria-required','true').removeAttr('aria-label');

  // ('.quantity__button.no-js-hidden').on('click', () => {
  //     $('.quantity__button.no-js-hidden[name="plus"]').attr('aria-label','Added');
  // });

  console.log("ready");
});

$(window).on('load', function (){
  // Roll 36
  $('img[src*="As_Feature_on_Desktop.webp"]').each((i, img) => {
    $(img).attr('alt',"Fullstar as Featured on Women'sHealth, Netflix, Delish, Sheknows, Daily Mail, Food&Wine, and Cosmopolitan");

    $(img).parent().contents().each((i, node) => {
      if(node.nodeType === 3) {
        node.remove();
      }
    });
  });
  
  console.log("load");
});

  